// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"81e8329c","455":"5d261783","977":"1212ea22"}[chunkId] + ".chunk.js";
};